import { Component, Vue } from 'vue-property-decorator';
import styles from './app.module.scss';
import WithRender from './app.html';
// components
import Breadcrumb from '@/components/Breadcrumb/breadcrumb';
// Helpers
import { getThemeColor, updateAppVariables } from './appTheme';

@WithRender
@Component({
  components: {
    Breadcrumb,
  },
})
export default class App extends Vue {
  public styles = styles;

  mounted() {
    this.updateUIFrameWork();
    updateAppVariables();
  }

  public updateUIFrameWork() {
    const { primary, secondary, lighterPrimary } = this.$vuetify.theme.themes.light;

    const lightTheme = this.$vuetify.theme.themes.light;
    lightTheme.primary = getThemeColor('primary') || primary;
    lightTheme.secondary = getThemeColor('secondary') || secondary;
    lightTheme.lighterPrimary = getThemeColor('lighter-primary') || lighterPrimary;
  }
}
